module.exports = __webpack_public_path__ + "static/media/premium-packs-active-dark-icon.cd0d486d.svg";